import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '../../base.component';
import { CriterionsService } from '../../services/criterions.service';
import { MemberModel } from '../../models/member.model';

@Component({
  selector: 'app-masar-criterion-preview',
  templateUrl: './masar-criterion-preview.component.html',
  styleUrls: ['./masar-criterion-preview.component.scss']
})
export class MasarCriterionPreviewComponent extends BaseComponent implements OnInit {
  criterion$ = this.criterionsService.criterion$;
  decisionInputs$ = this.criterionsService.decisionInputs$;
  currentTab = 0;
  member: MemberModel = null;

  constructor(private criterionsService: CriterionsService) { super(); }

  ngOnInit() {
    this.criterion$
      .pipe(takeUntil(this.destroy$))
      .subscribe(_ => this.member = null);
  }

}
